import cloudServiceModule from '../cloudService.module';

export default cloudServiceModule.factory(
    'systemApiService',
    (__env, $http, $q) => {
        return {
            getConfigurations
        };

        function getConfigurations() {
            var deferred = $q.defer();
            $http
                .get(`${__env.cloudApiUrl}/api/v2/system/configurations`)
                .then(
                    response => deferred.resolve(response.data),
                    response => deferred.reject(response.data)
                );
            return deferred.promise;
        }
    }
);



// WEBPACK FOOTER //
// ./modules/cloudService/system/systemApi.service.js